module.exports = __webpack_public_path__ + "static/media/error.37bc8f7a.svg";